export default __webpack_public_path__ + "logo.06419e032ff6a8c49342b2b0c938802b.svg";